import styled from 'styled-components';

export const BillingDetails = styled.div`
  display: flex;
  font-family: Platform Web;
  padding: 3em;
`;
